module.exports = __webpack_public_path__ + "static/media/A1.c2cfda2c.jpg";